module.exports = __webpack_public_path__ + "static/media/LeagueAvatar.b884cb8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LeagueAvatar.svg
// module id = 434
// module chunks = 0